import { Box, Stack } from '@mui/material';
import { Footer } from 'components/Footer';
import { SimpleHeader } from 'components/SimpleHeader';

import type { FC, ReactNode } from 'react';

type PaymentLayoutProps = {
  children: ReactNode;
};

const PaymentLayout: FC<PaymentLayoutProps> = ({ children }) => (
  <Stack direction="column" alignItems="center">
    <SimpleHeader />

    <Box
      component="main"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        maxWidth: '545px',
        width: '100%',
        minHeight: (theme) => `calc(100vh - ${theme.customStyling.appBar.secondaryHeight})`,
        marginTop: (theme) => theme.customStyling.appBar.secondaryHeight,
      }}
    >
      {children}
    </Box>

    <Footer />
  </Stack>
);

export default PaymentLayout;
